import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { logger } from './services/logger'
import { applyBranding } from './config/branding'
import { useAuthStore } from './stores/auth'

// Apply Incentit IQ branding
applyBranding()

// Initialize the app
const app = createApp(App)

// Add Pinia store
const pinia = createPinia()
app.use(pinia)

// Initialize auth store from localStorage before router
const authStore = useAuthStore()
authStore.initializeFromStorage().then(() => {
  logger.info('Auth store initialized from storage', { 
    isAuthenticated: authStore.isAuthenticated 
  })
}).catch(err => {
  logger.error('Failed to initialize auth store', { error: err })
})

// Add router
app.use(router)

// Global error handler
app.config.errorHandler = (error, instance, info) => {
  logger.error('Global error handler', { error, info })
  console.error('Vue Error:', error, info)
}

// Mount the app
app.mount('#app')

// Log successful initialization
logger.info('Vue application initialized successfully', {
  environment: import.meta.env.MODE,
  baseUrl: import.meta.env.BASE_URL
})
